/**
 * FireCMS enum değerleri.
 * Key'ler Flutter / Firestore string value ile birebir aynıdır.
 * Hedef app: e:\Yazilim\FlutterProjects\octo_ai
 */

export const toolTypeEnumValues = {
    question_solver: "Soru çözücü",
    ai_teacher: "AI öğretmen",
    pdf_reader: "PDF okuyucu",
    youtube_summarizer: "YouTube özetleyici",
    error_analyzer: "Hata analizi",
    essay_wizard: "Kompozisyon",
    math_guide: "Matematik rehberi",
    similar_question_generator: "Benzer soru",
    formula_extractor: "Formül çıkarıcı",
    concept_simplifier: "Kavram sadeleştirici",
    book_analyzer: "Kitap analizi",
    academic_editor: "Akademik editör",
    grammar_checker: "Dil bilgisi",
    tutor_translator: "Çeviri",
    smart_quiz_maker: "Akıllı quiz",
} as const;

export const quizDifficultyEnumValues = {
    easy: "Kolay",
    medium: "Orta",
    hard: "Zor",
} as const;

export const quizStatusEnumValues = {
    in_progress: "Devam ediyor",
    completed: "Tamamlandı",
} as const;

export const optionKeyEnumValues = {
    A: "A",
    B: "B",
    C: "C",
    D: "D",
} as const;

/** Cihaz / kullanıcı platform — Flutter Helper.platformName */
export const platformEnumValues = {
    android: "Android",
    ios: "iOS",
    unknown: "Bilinmiyor",
} as const;

export const feedbackSourceEnumValues = {
    rate_dialog: "Puanlama diyaloğu",
    settings: "Ayarlar",
} as const;

/** Rate dialog sonucu — Flutter RATE_DIALOG_ACTION.value */
export const rateDialogActionEnumValues = {
    rate_store: "Mağazaya yönlendirildi",
    give_feedback: "Geri bildirim",
    dismiss: "Kapattı",
} as const;

export const videoSolutionStatusEnumValues = {
    idle: "Boş",
    processing: "İşleniyor",
    success: "Hazır",
    failed: "Başarısız",
} as const;

export const chatRoleEnumValues = {
    user: "Kullanıcı",
    assistant: "Asistan",
    system: "Sistem",
} as const;
